import { environment } from '@/environments/environment';

/** Comptes officiels : alimentent le graphe d'entités des moteurs (`sameAs`). */
const SOCIAL_PROFILES = [
	'https://x.com/TeamPepsMAX',
	'https://www.twitch.tv/fefegg',
	'https://www.youtube.com/@TeamPeps',
	'https://www.instagram.com/teampeps/',
	'https://www.tiktok.com/@teampeps',
];

/**
 * Identité du club, posée sur toutes les pages.
 *
 * `SportsOrganization` plutôt qu'`Organization` : c'est ce qui rattache le club
 * à ses équipes et à ses évènements sportifs. Le bloc `WebSite` associé donne
 * son nom au site dans les résultats de recherche.
 */
export function buildOrganizationJsonLd(): Record<string, unknown> {
	const site = environment.siteUrl.replace(/\/+$/, '');

	return {
		'@context': 'https://schema.org',
		'@graph': [
			{
				'@type': 'SportsOrganization',
				'@id': `${site}/#organization`,
				name: 'Team Peps',
				alternateName: 'Peps',
				url: site,
				// `logo` attend le logo du club, pas une bannière. Dérivé 512x512 du
				// logo officiel : l'original fait 6013x6013 pour près d'un mégaoctet,
				// téléchargé à chaque passage d'un robot pour aucun gain.
				logo: {
					'@type': 'ImageObject',
					url: `${site}/assets/images/seo/logo-512.png`,
					width: 512,
					height: 512,
				},
				image: `${site}/assets/images/seo/og-banner.jpg`,
				foundingDate: '2022',
				sport: 'Esports',
				sameAs: SOCIAL_PROFILES,
			},
			{
				'@type': 'WebSite',
				'@id': `${site}/#website`,
				url: site,
				name: 'Team Peps',
				inLanguage: ['fr-FR', 'en-US'],
				publisher: { '@id': `${site}/#organization` },
			},
		],
	};
}
